import eventEmitter from 'utilities/event-emitter';
import { ChatBotProvider } from './chat-bot-context';
import React, { useEffect, useState } from 'react';
import StorageService from 'api-services/storage-service';

const ChatBotContainer = ({ children }) => {
  const [selectedBot, setSelectedBot] = useState(null);
  const [botName, setBotName] = useState(null);

  useEffect(() => {
    const onBotSelectionUpdate = (bot) => {
      if(bot.clear) {
        if(bot.forced || StorageService.getItem('selectedBot') === bot.id) {
          setSelectedBot(null);
          setBotName(null);
          StorageService.removeItem('selectedBot');
          StorageService.removeItem('selectedBotName');
        }
        return;
      }

      if(bot.id) {
        setSelectedBot(bot.id);
        StorageService.setItem('selectedBot', bot.id);
      }

      if(bot.bot_name) {
        setBotName(bot.bot_name);
        StorageService.setItem('selectedBotName', bot.bot_name);
      }
    };

    onBotSelectionUpdate({ id: StorageService.getItem('selectedBot'), bot_name: StorageService.getItem('selectedBotName') });

    // to notify changes in bot selection from chatbot list.
    eventEmitter.on('botSelected', onBotSelectionUpdate);

    // Clean up the listener when the component unmounts.
    return () => {
      eventEmitter.off('botSelected', onBotSelectionUpdate);
    };
  }, []);

  return (
    <ChatBotProvider
      value={{
        selectedBot,
        botName,
      }}>
      {children}
    </ChatBotProvider>
  );
};

export default ChatBotContainer;
